import * as React from 'react';
import { Icon } from 'sos-common/js/components/Icon/icon';
export interface RemoveItemButtonProps {
  className?: string;
  onClick(e: React.MouseEvent<HTMLButtonElement>): void;
  text: string;
}

export function RemoveItemButton(props: RemoveItemButtonProps) {
  return (
    <button className="remove" onClick={props.onClick}>
      {props.text} <Icon iconType="Paperbin" /> 
    </button>
  );
}
